<template>
<div class="chapter">
<div class="inner_page">
<section class="level1 hidden" data-number="1" id="map-central-italia">
<h1 class="hidden" data-number="1">Map – Central Italia</h1>
<div class="map">
<img alt="Central Italia" src="media/file3.jpg"/>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?8f6d4b08